import { render } from "./Tab1.vue?vue&type=template&id=196f6adc&scoped=true&ts=true"
import script from "./Tab1.vue?vue&type=script&lang=ts"
export * from "./Tab1.vue?vue&type=script&lang=ts"

import "./Tab1.vue?vue&type=style&index=0&id=196f6adc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196f6adc"]])

export default __exports__